<section id="story" class="case-study-area bg-fffbf5">
    <div class="case-study-slides owl-carousel owl-theme">
        <div class="single-case-study-item ptb-100" *ngFor="let singleCaseStudyItemContent of singleCaseStudyItem;">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="case-study-content">
                            <span class="sub-title"><img src="https://imgvid.blob.core.windows.net/imgvid/star-icon.png" alt="image"> {{singleCaseStudyItemContent.subTitle}}</span>
                            <h2>{{singleCaseStudyItemContent.title}}</h2>
                            <p>{{singleCaseStudyItemContent.paragraphText1}}</p>
                            <p>{{singleCaseStudyItemContent.paragraphText2}}</p>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="case-study-image">
                            <img [src]="singleCaseStudyItemContent.img" alt="image">
                        </div>
                    </div>
                </div>
                <div class="row pt-100">
                    <div class="col-4" *ngFor="let case of Cases;">
                        <a routerLink='{{case.location}}'>
                            <div class="case-info-box">
                                <div class="back-icon">
                                    <i class='{{case.icon}}'></i>
                                </div>
                                <div class="icon">
                                    <i class='{{case.icon}}'></i>
                                </div>
                                <h3>{{case.title}}</h3>
                                <p>{{case.subTitle}}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>